import { DialogTitle, Typography } from "@material-ui/core";
import CloseIcon from "@mui/icons-material/Close";
import {
    Dialog,
    DialogContent,
    Grid,
    IconButton,
    Paper,
    styled
} from "@mui/material";
import { compose } from "@reduxjs/toolkit";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { ButtonCompo } from "../../components/Comman/Button";
import DynamicFormWithoutValidation from "../../components/dynamicscreens/DynamicFormWithoutValidation";
import { withRouter } from "../../components/withRouter";
import { blackColor } from "../../config/ColorObj";
import {
    noInternetMsg
} from "../../config/messageconstant";
import { mandatoryCheck, ValidationCheck } from "../../config/ValidationCheck";
import { OutletEnquiryJson } from "../../DynamicFormsJson/MastersJSON/outletEnquiry";
import { showLoador, showNotification } from "../Landing/Landing.slice";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    "& .MuiDialogContent-root": {
        padding: theme.spacing(2),
    },
    "& .MuiDialogActions-root": {
        padding: theme.spacing(1),
    },
}));

const BootstrapDialogTitle = (props) => {
    const { classes, children, onClose, ...other } = props;

    return (
        <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
            {children}
            {onClose ? (
                <IconButton
                    aria-label="close"
                    onClick={onClose}
                    sx={{
                        position: "absolute",
                        right: 8,
                        top: 8,
                        color: (theme) => theme.palette.grey[500],
                    }}
                >
                    <CloseIcon />
                </IconButton>
            ) : null}
        </DialogTitle>
    );
};

BootstrapDialogTitle.propTypes = {
    children: PropTypes.node,
    onClose: PropTypes.func.isRequired,
};

class ConvertEnquiryPopUp extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dynamicMasterData: {
            },
            fullName: "",
            areaHierarchyData: {},
            userTypeId: "",
            isNewArea: "",
            fieldData: {},
            formErrors: {},
            adminFlag: false,
        };
    }
    async componentDidMount() {
        const {
            showNotification,
        } = this.props;
        if (navigator.onLine) {
        } else {
            showNotification({ msg: noInternetMsg, severity: "error" });
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.brandList !== nextProps.brandList) {
            if (this.props.brandList?.brand !== nextProps.brandList?.brand) {
                this.setState({
                    dynamicMasterData: {
                        ...this.state.dynamicMasterData,
                        brandDetail: nextProps.brandList?.brand,
                    },
                });
            }
        }
    }

    handleClose = () => {
        const { handleCloses } = this.props;
        handleCloses();
    };

    checkValidationOnSubmit = () => {
        const { fieldData, isNewArea, adminFlag, userTypeId } = this.state;

        let fieldMetaForCondition = OutletEnquiryJson.fieldMetaForConvert;
        const mandatoryCheckErrors = mandatoryCheck({
            fieldData,
            fieldMeta: fieldMetaForCondition,
        });
        this.setState({
            formErrors: mandatoryCheckErrors.formErrors,
        });

        if (mandatoryCheckErrors.formValid) {
            const ValidationCheckErrors = ValidationCheck({
                fieldData,
                fieldMeta: fieldMetaForCondition,
            });
            this.setState({
                formErrors: ValidationCheckErrors.formErrors,
            });
            return ValidationCheckErrors.formValid;
        } else {
            return false;
        }
    };

    onSave = () => {
        const { fieldData } = this.state;
        const { selectedRows, tabValue } = this.props;

    };

    render() {
        const { open } = this.props;
        const {
            dynamicMasterData,
            fullName,
            fieldData,
            formErrors,
            isNewArea,
            adminFlag,
            userTypeId,
        } = this.state;


        return (
            <>
                <BootstrapDialog
                    onClose={this.handleClose}
                    aria-labelledby="customized-dialog-title"
                    open={open}
                    fullWidth
                    maxWidth="lg"
                >
                    <BootstrapDialogTitle
                        id="customized-dialog-title"
                        onClose={this.handleClose}
                    >
                        Add Below Details To Convert Enquiry
                    </BootstrapDialogTitle>
                    <DialogContent dividers>
                        <Paper
                            sx={{
                                padding: 2,
                            }}
                            elevation={0}
                        >
                            <DynamicFormWithoutValidation
                                dynamicMasterData={dynamicMasterData}
                                screenTitle={""}
                                fieldMeta={OutletEnquiryJson.fieldMetaForConvert}
                                apiBaseURL={OutletEnquiryJson.apiBaseURL}
                                formErrors={formErrors}
                                showSaveBtn={false}
                                showSaveBtnMain={false}
                                getByIdApi={true}
                                callApi={true}
                                fieldData={fieldData}
                                onDataChange={this.onDataChange}
                                showBackToList={true}
                            />

                            <Grid
                                item
                                sm={12}
                                xs={12}
                                md={12}
                                lg={12}
                                container
                                justifyContent="right"
                            >
                                <ButtonCompo
                                    size="medium"
                                    type="button"
                                    variant="contained"
                                    name="Save"
                                    onClick={this.onSave}
                                />
                            </Grid>
                        </Paper>
                    </DialogContent>
                </BootstrapDialog>
            </>
        );
    }
}
const mapStateToProps = (state) => ({
});
const mapDispatchToProps = {
    showNotification,
    showLoador,
};
export default compose(
    withRouter,
    connect(mapStateToProps, mapDispatchToProps)
)(ConvertEnquiryPopUp);
